import React from "react";
import { Card, CardHeader, CardBody, CardTitle, Row, Col } from "reactstrap";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine";
import { connect } from "react-redux";
import loadingAction from "../../core/redux/actions/loadingAction";
import ReactTable from "react-table";
import TablePagination from "components/Table/TablePagination";
import strings from "../../core/translate";
import SelectRow from "../../components/Select/SelectRow";
import { Scopes } from "../../shared/scopes.enum";
import GarageSectionHeader from "../../components/Garage/GarageSectionHeader";

class MerchantBranchRatingsList extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      dataSource: [],
      merchants: [],
      branches: [],
      selectedMerchant: "",
      selectedBranch: "",
      branchName: "",
      globalFilter: "",
      startDateFilter: null,
      endDateFilter: null,
      canWrite: false,
    };
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const merchantIdFromStorage = sessionStorage.getItem("merchantId");
    const routeState = this.props.location.state || {};
    const { selectedBranch } = this.props.match.params;
    // opened from a garage record, so the garage is fixed for this page
    const branchId =
      selectedBranch && selectedBranch !== ":selectedBranch"
        ? selectedBranch
        : "";
    const selectedMerchant =
      merchantIdFromStorage || routeState.selectedMerchant || "";

    this.setState(
      {
        canWrite: this.hasPermission([Scopes.MERCHANTS_BRANCHES_RATINGS_WRITE]),
        selectedMerchant,
        selectedBranch: branchId,
        branchName: routeState.branchName || "",
      },
      () => {
        if (selectedMerchant) {
          this.fetchBranches();
        } else {
          this.fetchMerchants();
        }
        if (branchId) {
          this.callPage();
        } else {
          this.setState({ isLoading: false });
        }
      }
    );
  }

  fetchMerchants = async () => {
    const response = await this.engine.getItem("merchants");
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        merchants: response.data.items.map((merchant) => ({
          value: merchant.id,
          label: merchant.name,
        })),
      });
      if (this.state.merchants.length === 1) {
        this.setState({
          selectedMerchant: this.state.merchants[0].value,
        });
        this.fetchBranches();
      }
    }
  };

  async fetchBranches() {
    const { selectedMerchant } = this.state;
    if (!selectedMerchant) return;
    const response = await this.engine.getItem(
      `merchants/${selectedMerchant}/branches`
    );
    if (response && response.status === 200) {
      const branches = response.data.items.map((branch) => ({
        value: branch.id,
        label: branch.name || branch.address,
      }));
      this.setState((prev) => ({
        isLoading: false,
        branches,
        branchName: prev.branchName || this.findBranchName(branches, prev),
      }));
    }
  }

  findBranchName(branches, state) {
    const match = branches.find((branch) => branch.value === state.selectedBranch);
    return match ? match.label : "";
  }

  async callPage() {
    const { selectedBranch } = this.state;
    if (!selectedBranch || selectedBranch === ":selectedBranch") return;

    const pathname = `merchants-branches/${selectedBranch}/ratings`;
    const response = await this.engine.getItem(pathname);
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        dataSource: response.data.items.map((item, key) => ({
          id: key,
          data: item,
          customer: `${item.customer.user.firstName} ${item.customer.user.lastName}`,
          rate: item.rate,
          comment: item.comment,
          created: new Date(item.createdAt),
          // actions: this.handleActions(key, item)
        })),
      });
    }
    this.props.loadingAction(false);
  }

  handlePage() {
    this.props.loadingAction(true);
    this.callPage();
  }

  // async handleDelete(valueid) {
  //     if (window.confirm(strings.confirmdelete)) {
  //         this.props.loadingAction(true);
  //         const { selectedBranch } = this.state;
  //         const result = await this.engine.deleteItem(`merchants-branches/${selectedBranch}/ratings`, valueid);
  //         if (result) {
  //             this.handlePage();
  //         }
  //         this.props.loadingAction(false);
  //     }
  // }

  // handleActions(index, item) {
  //     return (
  //         <UncontrolledDropdown>
  //             <DropdownToggle
  //                 aria-expanded={false}
  //                 aria-haspopup={true}
  //                 caret
  //                 className="btn-round btn-block"
  //                 color="primary"
  //                 data-toggle="dropdown"
  //                 id="dropdownMenuButton"
  //                 type="button"
  //             >
  //                 {strings.actions}
  //             </DropdownToggle>
  //             <DropdownMenu>
  //                 <DropdownItem
  //                     eventkey="2"
  //                     onClick={() => this.handleEdit(index, item.id)}
  //                 >
  //                     {strings.edit}
  //                 </DropdownItem>
  //                 <DropdownItem
  //                     variant="danger"
  //                     eventkey="1"
  //                     onClick={() => this.handleDelete(item.id)}
  //                 >
  //                     {strings.delete}
  //                 </DropdownItem>
  //             </DropdownMenu>
  //         </UncontrolledDropdown>
  //     );
  // }
  // Handle merchant selection change
  handleMerchantSelect = (event) => {
    const selectedMerchant = event.value;

    if (selectedMerchant !== this.state.selectedMerchant) {
      this.setState(
        { selectedMerchant, selectedBranch: "", branches: [], dataSource: [] },
        () => {
          this.fetchBranches();
        }
      );
    }
  };

  // Handle branch selection change
  handleBranchSelect = (event) => {
    const selectedBranch = event.value;
    this.setState(
      {
        selectedBranch,
        branchName: this.findBranchName(this.state.branches, { selectedBranch }),
      },
      () => {
        this.props.history.push(
          `/admin/merchants-branches/${selectedBranch}/ratings`
        );
        this.callPage();
      }
    );
  };

  // handleAdd() {
  //     const { selectedMerchant, selectedBranch } = this.state;

  //     if (!selectedMerchant || selectedMerchant === ':selectedMerchant' ) {
  //         alert("Please select a Merchant.");
  //         return;
  //     }

  //     if (!selectedBranch || selectedBranch === ':selectedBranch') {
  //         alert(strings.select + " " + strings.branch);
  //         return;
  //     }

  //     // Push the selectedMerchant and selectedBranch to the history
  //     this.props.history.push({
  //         pathname: `/admin/merchants-branches/${selectedBranch}/ratings/add`,
  //         state: { selectedMerchant, selectedBranch }
  //     });
  // }

  // handleEdit(index, dataid) {
  //     const data = this.state.dataSource[index].data;
  //     const { selectedMerchant, selectedBranch } = this.state;
  //     if (!selectedBranch || selectedBranch === ':selectedBranch') {
  //         alert(strings.select + " " + strings.branch);
  //         return;
  //     }

  //     // Push the selectedMerchant and selectedBranch along with the data to the history
  //     this.props.history.push({
  //         pathname: `/admin/merchants-branches/${selectedBranch}/ratings/edit/${dataid}`,
  //         state: { selectedMerchant, selectedBranch },
  //         data
  //     });
  // }

  render() {
    const {
      dataSource,
      isLoading,
      merchants,
      branches,
      selectedMerchant,
      selectedBranch,
      branchName,
    } = this.state;
    const isGarageScoped = Boolean(selectedBranch);

    let columns = [
      { Header: `${strings.customer} ${strings.name}`, accessor: "customer" },
      { Header: strings.rate, accessor: "rate" },
      { Header: strings.comment, accessor: "comment" },
      {
        Header: strings.created,
        accessor: "created",
        Cell: (row) => row.value.toLocaleDateString(),
      },
      // { Header: strings.actions, accessor: "actions", sortable: false, filterable: false }
    ];

    return (
      <>
        <div className="content">
          <GarageSectionHeader
            branchId={selectedBranch}
            branchName={branchName}
            merchantId={selectedMerchant}
            active="ratings"
            history={this.props.history}
          />
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4" className="pull-left">
                    {isGarageScoped ? strings.ratings : ""}
                  </CardTitle>
                  {!isGarageScoped &&
                    !sessionStorage.getItem("merchantId") &&
                    merchants.length !== 1 && (
                      <SelectRow
                        label={strings.merchant}
                        name="selectedMerchant"
                        defaultValue={selectedMerchant}
                        data={merchants}
                        changeInput={(e) => this.handleMerchantSelect(e)}
                        placeholder={strings.select}
                      />
                    )}
                  {!isGarageScoped && (
                    <SelectRow
                      key={selectedMerchant || "default"}
                      label={strings.garage}
                      name="selectedBranch"
                      defaultValue={selectedBranch}
                      data={branches}
                      changeInput={(e) => this.handleBranchSelect(e)}
                      placeholder={strings.select}
                      viewonly={!selectedMerchant}
                    />
                  )}
                </CardHeader>
                <CardBody>
                  <ReactTable
                    previousText={strings.previous}
                    nextText={strings.next}
                    loadingText={strings.loading}
                    noDataText={strings.nodata}
                    pageText={strings.page}
                    data={dataSource}
                    defaultFilterMethod={this.filterCaseInsensitive}
                    filterable
                    loading={isLoading}
                    columns={columns}
                    defaultPageSize={10}
                    showPaginationTop={false}
                    showPaginationBottom
                    PaginationComponent={TablePagination}
                    className="-striped -highlight primary-pagination"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadingAction: (payload) => dispatch(loadingAction(payload)),
});
export default connect(null, mapDispatchToProps)(MerchantBranchRatingsList);
